import { render, staticRenderFns } from "./IndexPc.vue?vue&type=template&id=0f0b04a0&scoped=true&"
import script from "./IndexPc.vue?vue&type=script&lang=js&"
export * from "./IndexPc.vue?vue&type=script&lang=js&"
import style0 from "./IndexPc.vue?vue&type=style&index=0&id=0f0b04a0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b04a0",
  null
  
)

component.options.__file = "IndexPc.vue"
export default component.exports